module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Theresa_480x480.1947992c.mp4";